import { defineMessages } from 'react-intl';

export const generalMessages = defineMessages({
  userName: {
    id: 'constants.messages.user-name',
    defaultMessage:
      '{givenName, select, undefined {} other {{givenName}}}{familyName, select, undefined {} other { {familyName}}}',
  },
  venueName: {
    id: 'constants.messages.venue-name',
    defaultMessage: '{venueName}{venueSubtitle, select, undefined {} other { ({venueSubtitle})}}',
  },
  goodwill_paid_tooltip: {
    id: 'constants.messages.goodwill-tooltip',
    defaultMessage: 'This user was reported via your dashboard as abusing our trial program. Learn more <a>here.</a>',
  },
  rtr_paid_tooltip: {
    id: 'constants.messages.rtr-paid-tooltip',
    defaultMessage: 'This user was identified as abusing our trial program. Learn more <a>here.</a>',
  },
});

// statuses for the reservations report table
export const statusMessages = defineMessages({
  attended: {
    id: 'constants.messages.attended',
    defaultMessage: 'Attended',
  },
  late_cancel_waived: {
    id: 'constants.messages.late-cancel-waived',
    defaultMessage: 'Late Cancel -- Policy Exception',
  },
  goodwill_paid: {
    id: 'constants.messages.goodwill-paid',
    defaultMessage: 'Reported trial program abuse',
  },
  rtr_paid: {
    id: 'constants.messages.rtr-paid',
    defaultMessage: 'Identified trial program abuse',
  },
  missed_class: {
    id: 'constants.messages.missed',
    defaultMessage: 'Missed',
  },
  user_late_cancel: {
    id: 'constants.messages.user-late-cancel',
    defaultMessage: 'User Late Cancel',
  },
  rebooked: {
    id: 'constants.messages.late-cancel-rebooked',
    defaultMessage: 'Late Cancel Rebooked',
  },
  premium: {
    id: 'constants.messages.premium',
    defaultMessage: 'Premium',
  },
  frequent_visitor: {
    id: 'constants.messages.frequent-visitor',
    defaultMessage: 'Frequent Visitor',
  },
  first_class_free: {
    id: 'constants.messages.first-class-free',
    defaultMessage: 'First Trial Reservation',
  },
});

export const languages = defineMessages({
  // order is relevant, default language should be the first
  'en-US': {
    id: 'languages.en-US',
    defaultMessage: 'English',
  },
  da: {
    id: 'languages.da',
    defaultMessage: 'Dansk',
  },
  'de-DE': {
    id: 'languages.de-DE',
    defaultMessage: 'Deutsch',
  },
  es: {
    id: 'languages.es',
    defaultMessage: 'Español',
  },
  'fr-FR': {
    id: 'languages.fr-FR',
    defaultMessage: 'Français',
  },
  ja: {
    id: 'languages.ja',
    defaultMessage: '日本語',
  },
  nb: {
    id: 'languages.nb',
    defaultMessage: 'Norsk',
  },
  'nl-NL': {
    id: 'languages.nl-NL',
    defaultMessage: 'Nederlands',
  },
  pt: {
    id: 'languages.pt',
    defaultMessage: 'Português',
  },
  'pt-BR': {
    id: 'languages.pt-BR',
    defaultMessage: 'Português (Brasil)',
  },
  sv: {
    id: 'languages.sv',
    defaultMessage: 'Svenska',
  },
  'zh-TW': {
    id: 'languages.zh-TW',
    defaultMessage: '繁體中文',
  },
});

export const errorMessages = defineMessages({
  default: {
    id: 'constants.messages.errors.default',
    defaultMessage: 'There was an error, please try again.',
  },
});
